"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Autorenew_exports = {};
__export(Autorenew_exports, {
  default: () => Autorenew_default
});
module.exports = __toCommonJS(Autorenew_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.70312 2.78906C8.83333 2.84115 8.9375 2.92578 9.01562 3.04297C9.09375 3.14714 9.13281 3.26432 9.13281 3.39453V7.32031C9.13281 7.5026 9.06771 7.65885 8.9375 7.78906C8.80729 7.90625 8.64453 7.96484 8.44922 7.96484C8.26693 7.96484 8.10417 7.90625 7.96094 7.78906C7.83073 7.65885 7.76562 7.5026 7.76562 7.32031V5.05469L5.96875 6.87109C5.30469 7.50911 4.84245 8.26432 4.58203 9.13672C4.32161 9.99609 4.29557 10.862 4.50391 11.7344C4.71224 12.6068 5.1224 13.3815 5.73438 14.0586C6.35938 14.7227 7.11458 15.2044 8 15.5039C8.18229 15.556 8.3125 15.6667 8.39062 15.8359C8.46875 15.9922 8.47526 16.1549 8.41016 16.3242C8.34505 16.4935 8.22786 16.6172 8.05859 16.6953C7.88932 16.7734 7.72005 16.7865 7.55078 16.7344C6.99089 16.5391 6.47656 16.2917 6.00781 15.9922C5.52604 15.6797 5.09635 15.3216 4.71875 14.918C4.34115 14.5143 4.02214 14.0651 3.76172 13.5703C3.5013 13.0885 3.30599 12.5742 3.17578 12.0273C3.04557 11.4805 2.98698 10.9271 3 10.3672C3.02604 9.82031 3.11719 9.28646 3.27344 8.76562C3.42969 8.24479 3.65104 7.75 3.9375 7.28125C4.23698 6.79948 4.58854 6.36328 4.99219 5.97266L6.88672 4.05859H4.36719C4.17188 4.05859 4.00911 3.99349 3.87891 3.86328C3.7487 3.73307 3.68359 3.57682 3.68359 3.39453C3.68359 3.22526 3.7487 3.07552 3.87891 2.94531C4.00911 2.8151 4.17188 2.75 4.36719 2.75H8.44922C8.48828 2.75 8.52734 2.75651 8.56641 2.76953C8.61849 2.76953 8.66406 2.77604 8.70312 2.78906ZM12.2969 17.7109C12.1667 17.6589 12.0625 17.5807 11.9844 17.4766C11.9062 17.3594 11.8672 17.2357 11.8672 17.1055V13.1797C11.8672 12.9974 11.9323 12.8477 12.0625 12.7305C12.1927 12.6003 12.3555 12.5352 12.5508 12.5352C12.7331 12.5352 12.8893 12.6003 13.0195 12.7305C13.1628 12.8477 13.2344 12.9974 13.2344 13.1797V15.4453L15.0312 13.6289C15.6953 12.9909 16.1576 12.2422 16.418 11.3828C16.6784 10.5104 16.7044 9.63802 16.4961 8.76562C16.2878 7.89323 15.8711 7.125 15.2461 6.46094C14.6341 5.78385 13.8854 5.29557 13 4.99609C12.8177 4.94401 12.6875 4.83984 12.6094 4.68359C12.5312 4.51432 12.5247 4.34505 12.5898 4.17578C12.6549 4.00651 12.7721 3.88281 12.9414 3.80469C13.1107 3.72656 13.2799 3.71354 13.4492 3.76562C14.0091 3.96094 14.5234 4.20833 14.9922 4.50781C15.474 4.82031 15.9036 5.17839 16.2812 5.58203C16.6589 5.98568 16.9779 6.4349 17.2383 6.92969C17.4987 7.41146 17.694 7.92578 17.8242 8.47266C17.9544 9.01953 18.013 9.57292 18 10.1328C17.974 10.6797 17.8828 11.2135 17.7266 11.7344C17.5703 12.2552 17.349 12.75 17.0625 13.2188C16.763 13.7005 16.4115 14.1367 16.0078 14.5273L14.1133 16.4414H16.6328C16.8281 16.4414 16.9909 16.5065 17.1211 16.6367C17.2513 16.7669 17.3164 16.9232 17.3164 17.1055C17.3164 17.2747 17.2513 17.4245 17.1211 17.5547C16.9909 17.6849 16.8281 17.75 16.6328 17.75H12.5508C12.5117 17.75 12.4661 17.75 12.4141 17.75C12.375 17.737 12.3359 17.724 12.2969 17.7109Z",
      fill: "currentColor"
    }
  )
);
const SvgAutorenew = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Autorenew_default = SvgAutorenew;
